import { Title } from '@zorro/design-system/v2/Title';
import { Grid, Stack, Text } from '@zorro/web/design-system';
import { ReactNode } from 'react';

import { SensitiveValue } from '../../SensitiveValue';

export type ReadonlyValueProps =
  | {
      id: string;
      label: ReactNode;
      value?: ReactNode | string | null;
      span?: number;
      isSensitive?: boolean;
      copyValue?: string | null;
      masked?: boolean;
    }
  | {
      id: string;
      title: string;
      masked?: boolean;
    };

const ReadonlyValue = (props: ReadonlyValueProps) => {
  if ('title' in props) {
    return (
      <Grid.Col>
        <Title order={4}>{props.title}</Title>
      </Grid.Col>
    );
  }

  const {
    label,
    value,
    span = 6,
    isSensitive = false,
    copyValue,
    masked,
  } = props;

  return (
    <Grid.Col span={span}>
      <Stack gap="xxs">
        <Text size="sm" fw={400} c="zorroGray.4">
          {label}
        </Text>

        {value ? (
          <SensitiveValue
            value={value}
            isSensitive={isSensitive}
            isMasked={masked}
            copyValue={copyValue}
          />
        ) : (
          <Text>-</Text>
        )}
      </Stack>
    </Grid.Col>
  );
};

type Props = {
  items: ReadonlyValueProps[];
};

export const ReadonlyValuesGrid = ({ items }: Props) => {
  return (
    <Grid gap="xl">
      {items.map((item) => (
        <ReadonlyValue key={item.id} {...item} />
      ))}
    </Grid>
  );
};
